export function toUpperCase(v: string) {
    return v && v.toUpperCase ? v.toUpperCase().trim() : v;
}
export function toUpperCaseList(list: string[]) {
    return list.map(function (v) {
        return toUpperCase(v);
    });
}
